import { render, staticRenderFns } from "./WorkIconNotification.vue?vue&type=template&id=396327d0"
import script from "./WorkIconNotification.vue?vue&type=script&lang=js"
export * from "./WorkIconNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports